// extracted by mini-css-extract-plugin
module.exports = {"header":"i_Qx","description":"i_Qy","title":"i_Qz","subtitle":"i_Q0"};